// This file is auto-generated by scripts/release.js
export const ROOT_VERSION = "26.35.0";
